<i
  class="icon"
  [ngClass]="className"
  [attr.aria-hidden]="ariaHidden"
  [attr.aria-label]="ariaLabel"
  role="img"
></i>
